module.exports = __webpack_public_path__ + "img/4.b96aeb98.jpg";